import Logger from '../../../utils/logger';
import { deepDefaults } from '../../../utils/objects';
import { saveLocalData } from '../../local-storage';
import { setHasMetadataOnBackend } from '../../ppt';
import { getMetadataDictionaryKey, getPresentationIdAndSlideId } from '../helpers';
import { SlideType, Metadata } from '../types';
import { METADATA_LOCAL_STORAGE_KEY } from './constants';
import { MetadataDictionary } from './types';

export async function setMetadata(
  presentationId: string,
  slideId: string,
  metadata: DeepPartial<Metadata>,
  shouldCallApi: boolean = true
) {
  const existingMetadata: MetadataDictionary = JSON.parse(
    localStorage.getItem(METADATA_LOCAL_STORAGE_KEY) ?? '{}'
  );

  const updatedMetadata: MetadataDictionary = { ...existingMetadata };

  const metadataId = getMetadataDictionaryKey(presentationId, slideId);

  const tempMetadata = deepDefaults(existingMetadata[metadataId], metadata);

  updatedMetadata[metadataId] = deepDefaults(
    {
      url: '',
      slideType: SlideType.HOME as SlideType,
    },
    tempMetadata
  );

  if (JSON.stringify(existingMetadata) === JSON.stringify(updatedMetadata)) return;

  localStorage.setItem(METADATA_LOCAL_STORAGE_KEY, JSON.stringify(updatedMetadata));

  if (!shouldCallApi) return;

  try {
    const response = await saveLocalData({ presentationId, slideId });
    if (response.message === 'failed') return;
    setHasMetadataOnBackend(true);
  } catch (error) {
    Logger.error(error);
  }
}

export function getMetadata<K extends keyof Metadata>(
  presentationId: string,
  slideId: string,
  key: K
): Metadata[K] | undefined;
export function getMetadata(presentationId: string, slideId: string): Metadata | undefined;
export function getMetadata<K extends keyof Metadata>(
  presentationId: string,
  slideId: string,
  key?: K
): Metadata | Metadata[K] | undefined {
  const metadataDictionary: Record<string, Metadata> = JSON.parse(
    localStorage.getItem(METADATA_LOCAL_STORAGE_KEY) ?? '{}'
  );
  const metadataId = getMetadataDictionaryKey(presentationId, slideId);

  if (!key) {
    return metadataDictionary[metadataId];
  }

  return metadataDictionary[metadataId]?.[key];
}
